<!--<h4 class="pull-left" style="padding-top: 7.5px;padding-right: 7.5px;">Walk History</h4>
<hr />-->
<div class="row">
  <div class="col-md-12">
    <div class="panel panel-danger">
      <div class="panel-heading clearfix" data-testid="walk-history-header">
        <div class="col-xs-12 col-sm-12 col-md-12 text-center">
          <h4 class="center-block">Walk History</h4>
        </div>
        <div class="col-xs-12 col-sm-8 col-md-10">
          <div class="col-xs-12 col-sm-12 col-md-6">
            <div class="col-xs-12 col-sm-6 col-md-6">
              <label class="control-label">
                Start Date
                <div class="pull-right">
                  <p class="input-group">
                    <input type="text" class="form-control" name="startDate"
                      data-testid="walk-history-start-date-selection" validate-on="blur" required
                      required-message="'Start Date is required'" bsDatepicker
                      [bsConfig]="{ containerClass: 'theme-red', dateInputFormat: 'YYYY-MM-DD' }" #dp="bsDatepicker"
                      [(ngModel)]="startDate" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-default" (click)="dp.show()"
                        [attr.aria-expanded]="dp.isOpen">
                        <i class="glyphicon glyphicon-calendar"></i>
                      </button>
                    </span>
                  </p>
                </div>
              </label>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6">
              <label class="control-label">
                End Date
                <div class="pull-right">
                  <p class="input-group">
                    <input type="text" class="form-control" name="endDate" data-testid="walk-history-end-date-selection"
                      validate-on="blur" bsDatepicker
                      [bsConfig]="{ containerClass: 'theme-red', dateInputFormat: 'YYYY-MM-DD' }" #dp2="bsDatepicker"
                      [(ngModel)]="endDate" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-default" (click)="dp2.show()">
                        <i class="glyphicon glyphicon-calendar"></i>
                      </button>
                    </span>
                  </p>
                </div>
              </label>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6">
            <span style="padding-left: 20px; padding-right: 7.5px;">
              {{totalMembers}} Members found [Duration:  {{totalHours}} Hrs  {{totalMinutes}}  Mins  ]
            </span>
            <div class="pull-right">
              <p class="input-group">
                <input id="inputSearchMembers" data-testid="search-filter" ng-focus="true" type="search" [(ngModel)]="filterMembers" class="form-control shortInputSearch" placeholder="Filter.." ng-Enter="search();">
                <span class="input-group-btn">
                  <button class="btn btn-primary" (click)="search();" data-testid="walk-history-search-button"><i class="glyphicon glyphicon-search"></i></button>
                  <button class="btn btn-primary" (click)="clearSearch();" data-testid="walk-history-clear-search"><i class="glyphicon glyphicon-remove-sign"></i></button>
                </span>
              </p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 hidden-sm hidden-xs">
            <label class="control-label form-control">
              Adj Comments:
              <input type="text" [(ngModel)]="newComments" class="col-xs-10 col-sm-10 col-md-10 pull-right"
                data-testid="adj-comments-bar" />
            </label>
          </div>
        </div>

        <div class="col-xs-12 col-sm-4 col-md-2">
          <div class="hidden-sm hidden-xs">
            <label>
              <input type="radio" [(ngModel)]="showDuration" data-testid="radio-less-than" value="Less" /> Less than {{ quickAdjHours }} Hrs
            </label><br />
            <label>
              <input type="radio" [(ngModel)]="showDuration" data-testid="radio-more-than" value="More" /> More than {{ quickAdjHours }} Hrs
            </label><br />
          </div>
          <div>
            <label> <input type="radio" [(ngModel)]="showDuration" data-testid="radio-sign-in-only" value="SignInOnly" /> Sign-in Only </label><br />
            <label> <input type="radio" [(ngModel)]="showDuration" data-testid="radio-all" value="All" /> All </label>
          </div>
        </div>
      </div>
      <div class="table-responsive" *ngIf="loadingMembers === false">
        <table class="table table-striped table-condensed">
          <thead>
            <tr>
              <th>#</th>
              <th>Last Name</th>
              <th>First Name</th>
              <th>House</th>
              <!--<th>Sign-In Date</th>-->
              <th>Sign-in</th>
              <!--<th>In-Source</th>-->
              <th>Sign-out</th>
              <!--<th>Out-Source</th>
              <th>Duration</th>-->
              <th style="text-align: right">Hours</th>
              <th style="text-align: right">Minutes</th>
              <th>KickedOff</th>
              <th>Comments</th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let member of walkHistoryRecords" data-testid="walk-history-row">
              <td>
                <!--<div *ngIf="member.ImageExists">
                  <img class="thumbnail" width="75px" height="50px" [src]="Content/images/members/{{member.MemberId}}.jpg" alt="{{member.MemberId}}">
                  <a ng-click="openEditMemberDialog(member.StrikeMemberId);" title="Edit {{member.MemberId}} details"><strong>{{member.MemberId}} </strong>  </a>
                </div>-->
                <div *ngIf="!member.ImageExists">
                  <strong><a
                    (click)="openEditMemberModal(member.StrikeMemberId);"
                    (keyup.enter)="openEditMemberModal(member.StrikeMemberId);"
                    [attr.data-testid]="'member-id-' + member.MemberId"
                    title="Edit {{member.MemberId}} details"
                    tabindex="0">{{member.MemberId}}</a></strong>
                </div>
              </td>
              <td data-testid="member-last-name">{{ member.LastName }}</td>
              <td data-testid="member-first-name">{{ member.FirstName }}</td>
              <td data-testid="member-house-id">{{ member.HouseId }}</td>
              <!--<td>{{member.WalkDate | date:'MM/dd/yyyy'}}</td>-->
              <td data-testid="member-sign-in-time">
                {{ member.SignInTime | date: "MM/dd/yyyy" }}
                <span style="padding-left: 20px; color: forestgreen; font-weight: bold">
                  {{ member.SignInTime | date: "HH:mm" }}</span>
              </td>
              <!--<td>{{member.SignInMethod}}</td>-->
              <td data-testid="member-sign-out-time">
                {{ member.SignOutTime | date: "MM/dd/yyyy" }}
                <span style="padding-left: 20px; color: red; font-weight: bold">
                  {{ member.SignOutTime | date: "HH:mm" }}</span>
              </td>
              <!--<td>{{member.SignOutMethod}}</td>
              <td>{{member.DurationInMinutes}}</td>-->
              <td style="text-align:right" data-testid="member-hours">{{member.Hours}}</td>
              <td style="text-align:right" data-testid="member-minutes">{{member.Minutes}}</td>
              <td data-testid="member-kickedoff">{{member.KickedOff}}</td>
              <td data-testid="member-comments">{{member.Comments  | slice:0:6}}</td>
              <td>
                <a  data-testid="edit-walk-modal-button"
                    (click)="openEditWalkModal(member)"
                    (keyup.enter)="openEditWalkModal(member)"
                    tabindex="0">Edit</a>
              </td>
              <td>
                <div class="hidden-sm hidden-xs">
                  <a data-testid="delete-button"
                     (click)="openDeleteModal(member)"
                     (keyup.enter)="openDeleteModal(member)"
                     tabindex="0">Delete</a>
                </div>
              </td>
              <td>
                <div class="hidden-sm hidden-xs">
                  <a data-testid="adj-button"
                     (click)="adjustHours(member)"
                     (keyup.enter)="adjustHours(member)"
                     tabindex="0">Adj to {{quickAdjHours}} Hrs</a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!--<div class="text-center">
          <custom-pager page="{{page}}" custom-path="{{customPath}}" pages-count="{{pagesCount}}" total-count="{{totalCount}}" search-func="search(page)"></custom-pager>
        </div>-->
      </div>
      <div *ngIf="loadingMembers === true">
        <div class="col-xs-4"></div>
        <div class="col-xs-4">
          <i class="fa fa-refresh fa-4x fa-spin"></i> <span class="label label-primary">Loading members...</span>
        </div>
        <div class="col-xs-4"></div>
      </div>
    </div>
  </div>
  <div class="panel-footer">
    <div class="text-center">
      <app-custom-pager [page]="page" [pagesCount]="pagesCount" (pageChange)="search($event)"></app-custom-pager>
    </div>
  </div>
</div>
